import script from "./forgot_password.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot_password.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__